import React from 'react'
import Layout from '../../components/layout/Layout'
import DeletedUsersTable from '../../elements/tables/users/DeletedUsersTable'

export default function DeletedUsers() {
  return (
    <div>
      <Layout>
        <DeletedUsersTable />
      </Layout>
    </div>
  )
}
